import { cloneElement, isValidElement, ReactElement } from "react";

// Interfaces
import { IExtendedRenderOptionProps } from "../interfaces";

// MUI
import { Stack } from "@mui/material";

export default function CustomRenderOption(props: Readonly<IExtendedRenderOptionProps>) {
	const { renderOptionCustomProps = undefined, ...additional } = props;

	const { customComponent = undefined } = renderOptionCustomProps || {};
	const { component = null } = customComponent || {};

	if (component && Boolean(isValidElement(component))) {
		return (
			<Stack width={1} direction={"row"}>
				{cloneElement(component as ReactElement, { ...additional })}
			</Stack>
		);
	}

	return null;
}
